import { configureStore } from '@reduxjs/toolkit';
import tenantJobEntryReducer from '../components/reducers/tenant-job-entry';
// eslint-disable-next-line import/prefer-default-export
export const store = configureStore({
  reducer: {
    tenantJobEntry: tenantJobEntryReducer,
  },
  devTools: true,
});
